export const GOAL_STRUCTURE_EVENT_NAMES = {
  CLICKED_STAIRCASE_HEADING: 'Clicked Staircase Heading',
  CLICKED_STAIRCASE_GOAL: 'Clicked Staircase Goal',
  CLICKED_ACCESS_POINT_TAB: 'Clicked Access Point Tab'
}
